import { Dialog, Typography } from "@material-ui/core"
import { FormContestarMsjComunicacion } from "./FormContestarMsjComunicacion"


export const RespuestaSolicitud = (props) => {
    return (
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={props.open}>
                <Typography variant="h6" style={{marginTop:'1rem', textAlign:'center'}}>Respuesta a solicitud cuit - {props.item.cuit}</Typography>
                <FormContestarMsjComunicacion cerrarModal={props.onClose} item={props.item}/>
        </Dialog>
    )
}